module.exports = __webpack_public_path__ + "img/logo_negro.eb08ebb9.svg";